import { IBatchjobLog } from "@mctypes/global.types";
import React, { useEffect, useState } from "react";
import BatchLogTable from "../../../../components/BatchLogTable/BatchLogTable";
import { useAppSelector } from "../../../../hooks";
import { doGetBatchJobLogs } from "../batchJobAPI";
import { Box, Stack } from "@mantine/core";

const BatchJobLogPage: React.FC<{}> = () => {
  const [logs, setLogs] = useState<IBatchjobLog[]>([]);
  const project = useAppSelector((state) => state.adminReducer.project);
  const activeBatchJob = useAppSelector((state) => state.batchJobReducer.activeBatchJob);

  const init = async () => {
    const getLogs = await doGetBatchJobLogs(project?._id, activeBatchJob?._id);
    setLogs(getLogs);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <Stack gap={0}>
      {logs.length > 0 ? (
        <BatchLogTable projectId={project?._id} logs={logs}></BatchLogTable>
      ) : (
        <Box mt="0.5rem">Ingen logger ennå</Box>
      )}
    </Stack>
  );
};

export default BatchJobLogPage;
